import React from 'react';
import PropTypes from 'prop-types';
import { Table } from 'semantic-ui-react';

const QNA = ({ questionsAndAnswers }) => {

  return (
    <Table celled striped selectable size="large">
      <Table.Header>
        <Table.Row>
          <Table.HeaderCell>No.</Table.HeaderCell>
          <Table.HeaderCell>Questions</Table.HeaderCell>
          <Table.HeaderCell>Your Answers</Table.HeaderCell>
          <Table.HeaderCell>Correct Answers</Table.HeaderCell>
          <Table.HeaderCell>Points</Table.HeaderCell>
        </Table.Row>
      </Table.Header>
      <Table.Body>
        {questionsAndAnswers.map((item, i) => {
          const isSingleSelect = typeof item.correct_answer === 'string'
          return <Table.Row key={i + 1}>
            <Table.Cell>{i + 1}</Table.Cell>
            <Table.Cell>{item.question}</Table.Cell>
            {isSingleSelect ? <>
              <Table.Cell>{item.user_answer}</Table.Cell>
              <Table.Cell>{item.correct_answer}</Table.Cell>
            </> : <>
              <Table.Cell>1. {item.user_answer[0]}<br/> 2. {item.user_answer[1]}</Table.Cell>
              <Table.Cell>1. {item.correct_answer[0]}<br/> 2. {item.correct_answer[1]}</Table.Cell>
            </>
            }
            <Table.Cell>{item.point}</Table.Cell>
          </Table.Row>
        })}
      </Table.Body>
    </Table>
  );
};

QNA.propTypes = {
  questionsAndAnswers: PropTypes.array.isRequired,
};

export default QNA;
